import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { CustomerService } from './Customer.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-customer-requirement',
  templateUrl: './customer-requirement.component.html',
  styleUrls: ['./customer-requirement.component.css'],
})
export class CustomerRequirementComponent implements OnInit {
  isLoading = new BehaviorSubject<boolean>(false);
  displayedColumns: string[] = [
    'SNo',
    'requirement',
    'interest_level',
    // 'createdAt',
    'status',
    'action',
  ];
  bucketurl = environment.bucketUrl;
  public ELEMENT_DATA: any[] = [];
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public selectedId: number | null = null;
  customerReq: FormGroup;
  interestLevelList: any = []
  dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);

  constructor(
    private customerService: CustomerService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.customerReq = this.fb.group({
      interest_level_id: ['', Validators.required],
      requirement: ['', Validators.required],
      status: ['', Validators.required],

    });
  }

  get f() { return this.customerReq.controls; }


  back() {
    this.clearForm();
    this.isCreate = false;
    this.isEdit = false;
    this.getCustomerReq();
  }

  clearForm() {
    this.submitted = false;
    this.customerReq.patchValue({
      status: '',
      requirement: '',
      interest_level_id: ''
    });
    this.selectedId = null;
  }

  ngOnInit() {
    this.getInterestLevel();
    this.getCustomerReq();
  }

  getCustomerReq() {
    this.isLoading.next(true);
    this.customerService.getCustomerReqMasterList().subscribe(
      (response) => {
        this.ELEMENT_DATA = response.body.data;
        this.dataSource.data = this.ELEMENT_DATA;
        this.isLoading.next(false);
      },
      (error) => {
        this.isLoading.next(false);
      }
    );
  }

  onSubmit() {
    this.submitted = true;

    if (this.customerReq.invalid) {
      return;
    }

    this.isLoading.next(true);

    if (this.isEdit) {
      if (this.selectedId !== null) {
        this.customerService
          .updateCustomerReqMaster(this.selectedId, this.customerReq.value)
          .subscribe(
            (response) => {
              let responseData = response.body;
              if (responseData.responseCode == 200) {
              this.toastr.success(
                'Customer requirement Master updated successfully'
              );
              this.clearForm();
              this.isEdit = false;
              this.getCustomerReq();
              this.isLoading.next(false);
            }else {
              this.isLoading.next(false);
              this.toastr.error(responseData.responseMessage)
            }
            },
            (error) => {
              this.toastr.error('Error updating Customer Master');
              this.isLoading.next(false);
            }
          );
      }
    } else {
      this.customerService
        .createCustomerReqMaster(this.customerReq.value)
        .subscribe(
          (response) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
            this.toastr.success('Customer  requirement created successfully');
            this.clearForm();
            this.isCreate = false;
            this.getCustomerReq();
            this.isLoading.next(false);
            } else {
              this.isLoading.next(false);
              this.toastr.error(responseData.responseMessage)
            }
          },
          (error) => {
            this.toastr.error('Error creating customer  requirement Master');
            this.isLoading.next(false);
          }
        );
    }
  }

  edit(element: any) {
    this.isEdit = true;
    this.isCreate = false;
    this.selectedId = element.id;
    this.customerReq.patchValue({
      status: element.status ? 1 : 0,
      requirement: element.requirement,
      interest_level_id: element.interest_level_id
    });
  }

  getInterestLevel() {
    let reqObject = {
      flag: 'list'
    }
    this.customerService.getInterestLevelMaster(reqObject).subscribe(
      (response: any) => {
        let responseData = response.body
        if (responseData.responseCode == 200) {
          this.interestLevelList = responseData.data
        }
      },
      (error: any) => {
      }
    );
  }

  public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const requirement = data.requirement.toLowerCase().includes(filter);
      const interest = data.interest_level?.interest_level.toLowerCase().includes(filter);
      return requirement || interest;
    };
      this.dataSource.filter = filterValue;
  }
   clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }
}
